module.exports = __webpack_public_path__ + "img/load.a047cee8.svg";